import { z } from 'zod';

export const documentAnalysisScopeSchema = z.enum(['DOCUMENT', 'ORGANIZATION']);

export type DocumentAnalysisScope = z.infer<typeof documentAnalysisScopeSchema>;

export const documentAnalysisItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  analysis_result_id: z.number().nullable(),
  scope: documentAnalysisScopeSchema.default('DOCUMENT'),
});

export type DocumentAnalysisItemApi = z.input<typeof documentAnalysisItemSchema>;
export type DocumentAnalysisItem = z.infer<typeof documentAnalysisItemSchema>;

export const documentAnalysisListSchema = z.object({
  items: z.array(documentAnalysisItemSchema),
  total: z.number(),
});

export type DocumentAnalysisListApi = z.input<typeof documentAnalysisListSchema>;
export type DocumentAnalysisList = z.infer<typeof documentAnalysisListSchema>;

export type DocumentAnalysisItemsByScope = Record<DocumentAnalysisScope, DocumentAnalysisItem[]>;

export const documentAnalysisResultSchema = z
  .object({
    id: z.number().int(),
    document_id: z.string().nullable(),
    analysis_type_id: z.number().int(),
    result_text: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .transform((raw) => ({
    id: raw.id,
    documentId: raw.document_id,
    analysisTypeId: raw.analysis_type_id,
    resultText: raw.result_text,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

export type DocumentAnalysisResultEntityApi = z.input<typeof documentAnalysisResultSchema>;
export type DocumentAnalysisResultEntity = z.infer<typeof documentAnalysisResultSchema>;

// Фиктивный documentId для макро-анализов, чтобы ключи стора/кеша были в едином формате
// и не приходилось обрабатывать null/undefined на каждом вызове.
export const ORGANIZATION_ANALYSIS_DOCUMENT_ID = 'organization';

export const normalizeAnalysisDocumentId = (documentId?: string | null): string =>
  documentId && documentId.length > 0 ? documentId : ORGANIZATION_ANALYSIS_DOCUMENT_ID;

export const isOrganizationAnalysisScope = (documentId?: string | null): boolean =>
  !documentId || documentId === ORGANIZATION_ANALYSIS_DOCUMENT_ID;
